import { ECountry } from 'App/i18n/i18n.types';

export const PERPAGE_EXTERNAL_SHIPMENTS = 50;

export const BR_HOW_TO_WORKS_LOGGI =
  'https://atendimento.nuvemshop.com.br/pt_BR/ponto-de-postagem/como-funciona-o-nuvem-envio-loggi-com-pontos-de-postagem';

export const BR_HOW_TO_WORKS_JADLOG =
  'https://atendimento.nuvemshop.com.br/pt_BR/-nuvem-envio-jadlog/como-funciona-o-nuvem-envio-jadlog-com-pontos-de-postagem';

export const BR_TUTORIALS_NUVEM_ENVIO =
  'https://www.youtube.com/playlist?list=PLyiCRRVy8KJRktE8EKDz5osQYHijWvMxV';
